import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { matchRoutes } from 'react-router-config'
import classNames from 'classnames'
import { ConfigProvider, Layout } from 'antd'
import { initTheme } from '_src/themes'
import { useAppSelector } from '_src/store/hooks'
import routes from '_src/routes'
import { GlobalWallet } from '_src/hooks/useWallet'
import { flattenArray, findArrayParents } from '../../utils'
import './index.less'
import PassHeader from '../../components/PassHeader'
import PassFooter from '../../components/PassFooter'
import { useAppDispatch } from '../../store/hooks'
import { setActiveUrl } from '_src/store/menu/reducer'
const { Content } = Layout
import el_GR from 'antd/es/locale/el_GR'

// import en_US from 'antd/lib/calendar/locale/en_US'
export default function PageLayout({ children, className }) {
  const { theme } = useAppSelector((store) => store.global)
  const history = useHistory()
  const dispatch = useAppDispatch()
  const { pathname } = useLocation()
  const routeArray = flattenArray(routes())
  const [show, setShow] = useState(false)
  // 导航操作 start
  const handleSetActiveUrl = (pathname) => {
    // 设置导航焦点
    const marchRoutes = matchRoutes(routeArray, pathname)
    const path = marchRoutes[0]?.match?.path || ''

    if (path) {
      const urls = findArrayParents(routes(), (data) => data.path === path)
      urls && dispatch(setActiveUrl(urls))
    }
  }
  const historyParameter = (pathname) => {
    const historyItem = routeArray.find((item) => item.path.split(/[/#]/)[1] === pathname.split(/[/#]/)[1])
    if (historyItem) {
      const { hideFooter = false } = historyItem
      setShow(hideFooter)
    }
  }
  useEffect(() => {
    // 检查并生成UUID
    const generateUUID = (timestamp) => {
      const chars = '0123456789abcdefghijklmnopqrstuvwxyz';
      let uuid = '';
      const seed = timestamp % chars.length;

      for(let i = 0; i < 32; i++) {
        const randomIndex = (seed + i) % chars.length;
        uuid += chars[randomIndex];
      }

      return uuid;
    }

    if(!localStorage.getItem('UUID')) {
      const timestamp = new Date().getTime();
      const uuid = generateUUID(timestamp);
      localStorage.setItem('UUID', uuid);
    }
    historyParameter(pathname)
    history.listen((historyLocation) => {
      // 每次路由变化都会执行这个方法
      historyParameter(historyLocation.pathname)
      const historyItem = routeArray.find((item) => item.path === historyLocation.pathname)
      if (historyItem) {
        const { hideFooter = false } = historyItem
        setShow(hideFooter)
      }

      handleSetActiveUrl(historyLocation.pathname)

      window && window.scrollTo(0, 0)
    })
  }, [history])
  useEffect(() => {
    //  设置导航焦点
    handleSetActiveUrl(pathname == '/' ? '/home' : pathname)
    // 钱包
    initTheme(theme || 'dark')
  }, [])
  return (
    <GlobalWallet.Provider value={''}>
      <ConfigProvider locale={el_GR}>
        <Layout className={classNames('aacPass-page-layout', className)}>
          <PassHeader />
          <Content className={classNames('cust-content')}>{children}</Content>
          {!show && <PassFooter />}
        </Layout>
      </ConfigProvider>
    </GlobalWallet.Provider>
  )
}
